import FormProvider from 'src/components/hook-form/form-provider';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import { RHFUploadSingleFileBanner } from 'src/components/hook-form/rhf-upload';
import { useBannersStore } from 'src/store/banners/banners.store';
import LoadingButton from '@mui/lab/LoadingButton';

export interface BannerFormProps {
  methods: any;
  onSubmit: VoidFunction;
  handleDropUrl: (acceptedFiles: File[]) => void;
  handleRemove: (fileToRemove: string | File) => void;
  handleRemoveAll: () => void;
  isSubmitting: boolean;
}

export default function BannerForm({
  methods,
  onSubmit,
  handleDropUrl,
  handleRemove,
  handleRemoveAll,
  isSubmitting,
}: BannerFormProps) {
  const { bannerDetails } = useBannersStore();
  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <RHFTextField name="name" label="Nome" />
            {bannerDetails?.text && <RHFTextField name="text" label="Texto" />}
            <RHFUploadSingleFileBanner
              name="url"
              accept={'image/*' as any}
              acceptAll={false}
              onDrop={handleDropUrl}
              onRemove={handleRemove}
              onRemoveAll={handleRemoveAll}
              showPreview
            />
            <Typography variant="overline" color="text.secondary">
              Tamanho recomendado: {bannerDetails?.recomendedSize}
            </Typography>
            <Stack direction="row">
              <Box flexGrow={1} />
              <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
                Salvar
              </LoadingButton>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </FormProvider>
  );
}
